import React from "react";

type Props = {};

const FYPriorConstructionHint: React.FC<Props> = (props: Props) => {
  return (
    <>
      <ul className="text-start text-greyDark leading-para">
        <li>
          In the case of construction of a house, the construction is considered to be completed
          when the local authority issues a occupancy certificate.
        </li>
        <li>
          You should select the FY previous to the year in which the construction is completed. For
          eg if the construction is completed on 20 July 2023 (FY 23-24), then you need to select FY
          22-23 from the drop down.
        </li>
      </ul>
    </>
  );
};

export default FYPriorConstructionHint;
